import { Button } from "js/Components/Button";
import { OneLineText } from "js/Components/OneLineText";

export default class PowerUpButton extends Button {

    protected nbAllowed:number = 3;
    protected nbAvailable:number = 3;

    protected available_txt: OneLineText;

    constructor(x:number, y:number, sprite:string, callback: ()=> void){
        super(x, y , sprite, callback);

        this.available_txt = new OneLineText(16, 40, "font", this.nbAllowed.toString(), 20, 20, 0.5, 0.5);
        this.addChild(this.available_txt);
    }

    public consumePowerUp() {
        this.nbAvailable = Math.max(this.nbAvailable - 1, 0);
        this.available_txt.text = this.nbAvailable.toString();
        if (this.nbAvailable == 0) {
            this.alpha = 0.5;
            this.interactive = false;
        }
    }
    
    public resetAllocation() {
        this.nbAvailable = this.nbAllowed;
        this.alpha = 1;
        this.interactive = true;
    }

    public get availablePowerUps(): number {
        return this.nbAvailable;
    }

}